"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Item = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _GlobalNavItem = require("./GlobalNavItem.styles");

var _util = require("../../../util");

var _WithGlobalNav = require("../WithGlobalNav/WithGlobalNav.provider");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Item = (0, _base["default"])("div", {
  target: "e1lvsiqp0",
  label: "Item"
})(_GlobalNavItem.styles.base, ";");
exports.Item = Item;

var GlobalNavItem = function GlobalNavItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isActive = _ref.isActive,
      title = _ref.title,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      onClick = _ref.onClick,
      as = _ref.as,
      noticeCount = _ref.noticeCount,
      alert = _ref.alert,
      iconRef = _ref.iconRef,
      icon = _ref.icon,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "isActive", "title", "isLeftSidebarCollapsed", "onClick", "as", "noticeCount", "alert", "iconRef", "icon"]);

  var _useContext = (0, _react.useContext)(_WithGlobalNav.WithGlobalNavContext),
      isLeftSidebarHidden = _useContext.isLeftSidebarHidden;

  return (0, _jsxRuntime.jsxs)(Item, {
    className: (0, _clsx["default"])({
      active: isActive,
      basic: isLeftSidebarCollapsed || isLeftSidebarHidden
    }, className),
    isLeftSidebarCollapsed: isLeftSidebarCollapsed || isLeftSidebarHidden,
    isActive: isActive,
    "data-test-id": title,
    onClick: onClick,
    noticeCount: (0, _util.normalizeCount)(noticeCount),
    alert: alert,
    children: [(0, _jsxRuntime.jsx)("div", {
      children: (0, _jsxRuntime.jsx)(_Tooltip["default"], {
        position: "right",
        title: title,
        strategy: "fixed",
        children: (0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({
          as: as,
          css: _GlobalNavItem.styles.iconButton,
          type: "icon",
          active: isActive
        }, otherProps), {}, {
          children: /*#__PURE__*/(0, _react.cloneElement)(icon, {
            ref: iconRef
          })
        }))
      })
    }), children]
  });
};

GlobalNavItem.propTypes = {
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  isActive: _propTypes.bool,

  /**
   * Title for tooltip, and data-test-id
   */
  title: _propTypes.string,
  isLeftSidebarCollapsed: _propTypes.bool,
  as: _propTypes.elementType,

  /**
   * Function(e)
   * Use e.currentTarget.dataset.testId to decide which nav is active
   */
  onClick: _propTypes.func,
  noticeCount: _propTypes.number,
  alert: _propTypes.bool,
  icon: _propTypes.node,

  /**
   * Icon button ref
   */
  iconRef: _propTypes.func
};
GlobalNavItem.defaultProps = {
  className: undefined,
  children: undefined,
  isActive: false,
  title: '',
  isLeftSidebarCollapsed: false,
  as: undefined,
  onClick: function onClick() {},
  noticeCount: 0,
  alert: false,
  icon: undefined,
  iconRef: undefined
};
var _default = GlobalNavItem;
exports["default"] = _default;
//# sourceMappingURL=GlobalNavItem.js.map